<template>
  <div
    class="flex flex-col items-center justify-center w-full h-full min-h-full overflow-y-auto scrolling-touch font-sans text-white bg-primary"
  >
    <div class="w-full h-full md:max-w-sm">
      <router-view />
    </div>
  </div>
</template>
